export default [
    {
        path: '/home',
        name: 'home',
        component: resolve => require.ensure([], () => resolve(require('@/views/home.vue')), 'home'),
        children:[
            {
                path: '/home/order',
                name: 'order',
                component: resolve => require.ensure([], () => resolve(require('@/views/order.vue')), 'order'),
            },
            {
                path: '/home/orderOther',
                name: 'orderOther',
                component: resolve => require.ensure([], () => resolve(require('@/views/orderOther.vue')), 'orderOther'),
            },
            {
                path: '/home/details',
                name: 'details',
                component: resolve => require.ensure([], () => resolve(require('@/views/details.vue')), 'details'),
            },
            {
                path: '/home/login',
                name: 'login',
                component: resolve => require.ensure([], () => resolve(require('@/views/login.vue')), 'login'),
                meta: {
                    title: '登录'
                }
            },
        ]
    },
    {
        path: '/home/verify',
        name: 'verify',
        component: resolve => require.ensure([], () => resolve(require('@/views/verify.vue')), 'verify'),
        meta: {
            title: '验证登录'
        }
    },

]


// WEBPACK FOOTER //
// ./src/router/main/home/index.js